var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgSortingUp = function SvgSortingUp(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "data-width-16": 8,
    "data-width-24": 11,
    viewBox: "0 0 7.6 12.1",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4.396.6v9.448l2.189-2.022a.6.6 0 0 1 .814.882l-3.196 2.95a.6.6 0 0 1-.814 0L.193 8.908a.6.6 0 1 1 .815-.882l2.188 2.022V.6a.6.6 0 1 1 1.2 0"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSortingUp);
export default ForwardRef;